// extracted by mini-css-extract-plugin
module.exports = {"Contact":"House_Contact__1kmPa","Contact__title":"House_Contact__title__38n0z","Contact__p":"House_Contact__p__3NXgV"};